/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  ActionIcon,
  FontWeight,
  ICON_ALERT_CIRCLE_OUTLINE,
  ICON_CHECK_CIRCLE_OUTLINE,
  ICON_DOWNLOAD_OUTLINE,
  Icon,
  Message,
  Popover,
  Spinner,
  SpinnerSize,
  Text,
} from '@doveit/bricks';
import { MarketingJobStatus } from '../../../domain/types';
import { useMarketingDesignExportJobContext } from '../../../contexts/marketing-design-export-job-context/MarketingDesignExportJobContext';
import * as styles from './DesignExportJobSummary.style';

const TITLE = 'Stato download design';

const DesignExportJobSummary: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(true);

  const { jobs, maxJobsInProgress } = useMarketingDesignExportJobContext();

  if (jobs.length === 0) {
    return null;
  }

  return (
    <Popover
      aria-label="Stato download design"
      placement="bottom-end"
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={(
        <ActionIcon
          icon={{ path: ICON_DOWNLOAD_OUTLINE }}
          size="M"
          label="Stato download design"
          emphasis="high"
        />
      )}
    >
      <div css={styles.popoverContent}>
        <Message
          type="neutral"
          message={TITLE}
          onDismiss={() => setIsOpen(false)}
          boxed
        >
          <Text.BodySmall fontWeight={FontWeight.LIGHT}>
            I download potrebbero richiedere alcuni secondi. <br /> Max {maxJobsInProgress} download per volta.
          </Text.BodySmall>
          <div
            data-testid="design-export-job-summary-jobs"
            css={styles.jobsList}
          >
            {jobs.map(({ job, design }, index) => (
              <React.Fragment key={job.id}>
                {index > 0 && <div css={styles.divider} />}
                <div
                  data-testid="design-export-job-item"
                  css={styles.jobItem}
                >
                  {job.status === MarketingJobStatus.IN_PROGRESS && (
                    <div css={styles.spinnerWrapper} aria-label="Job in corso">
                      <Spinner size={SpinnerSize.SMALLER} color="neutrals.medium" />
                    </div>
                  )}
                  {job.status === MarketingJobStatus.SUCCESS && (
                    <Icon
                      path={ICON_CHECK_CIRCLE_OUTLINE}
                      size={20}
                      color="success.default.low"
                      aria-label="Job completato"
                    />
                  )}
                  {job.status === MarketingJobStatus.FAILED && (
                    <Icon
                      path={ICON_ALERT_CIRCLE_OUTLINE}
                      size={20}
                      color="critical.default.low"
                      aria-label="Job fallito"
                    />
                  )}
                  <div css={styles.jobTitleWrapper}>
                    <Text.BodySmall fontWeight={FontWeight.REGULAR}>{design.title}</Text.BodySmall>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </Message>
      </div>
    </Popover>
  );
};

export default DesignExportJobSummary;
